module.exports = __webpack_public_path__ + "img/kachel_BEWEGLICHKEIT_colustrumliquid.9b62d6b0.png";